module.exports = __webpack_public_path__ + "vpmobile/static/media/news-file.29c884fc.svg";